module.exports = __webpack_public_path__ + "static/govlab-546d6f32156f9293d3a23593c7409aa2.png";